// extracted by mini-css-extract-plugin
export default {"home_Page":"HomePage_home_Page__MFqJt","contact":"HomePage_contact__HqJrH"};